<template>
    <tr>
        <td class="capacity__cell">
            {{ row.location.name }}
        </td>

        <td v-for="cell in row.cells" class="capacity__cell">
            <publication-capacity-cell :cell="cell"></publication-capacity-cell>
        </td>
    </tr>
</template>

<script>
    import PublicationCapacityCell from '@/components/Panels/Publications/PublicationBasedChannelCapacityPanel/PublicationCapacityCell'
    
    export default {
        components: {PublicationCapacityCell},
        
        props: ['row']
    }
</script>
